<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'SERVICE.TITLE' | translate}}</h2>
    <ntr-add-button [openView]="'service/add'"></ntr-add-button>

    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'service'" [modelView]="'service'" [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['','Name','Code']" (onDeleteQuery)="deleteService($event)"></ntr-datatable>
</div>